import _Object$defineProperty from "@babel/runtime-corejs2/core-js/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs2/core-js/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";
import "core-js/modules/es6.regexp.to-string";
import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/esm/assertThisInitialized";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime-corejs2/helpers/esm/inherits";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import { logger } from '@origin-digital/reporting-client';
import { eventDispatcher, SacAction, TOPICS } from '@origin-digital/event-dispatcher';
import { SharedAppContextV2 } from './SharedAppContextV2';
import { fetchSac } from './service/UserService';
import { dispatchErrorEvent, dispatchNoErrorEvent } from './service/ErrorEventService';
import { findChangedState, getStateChangeFromQueryParams, updateState } from './service/StateService';
import { AemContextHub } from './aemContextHub';
import { updateStorage } from './service/StorageService';
import { isNative as isNativeFn } from './helpers';
import { addStorageUpdatedListener, readStorage, removeStorageUpdatedListener, srcUniqueId } from './sacStorage';
import { queryState } from './service/QueryService';
import { getInitialisedState } from './service/InitialisationService';

var SharedAppContextV2Provider = /*#__PURE__*/function (_React$Component) {
  _inherits(SharedAppContextV2Provider, _React$Component);

  var _super = _createSuper(SharedAppContextV2Provider);

  function SharedAppContextV2Provider(props, state) {
    var _this;

    _classCallCheck(this, SharedAppContextV2Provider);

    _this = _super.call(this, props, state);

    _defineProperty(_assertThisInitialized(_this), "sacListenerUnSub", void 0);

    _defineProperty(_assertThisInitialized(_this), "storageListenerUnSub", void 0);

    _defineProperty(_assertThisInitialized(_this), "showErrorBanner", false);

    _defineProperty(_assertThisInitialized(_this), "queryParams", void 0);

    _defineProperty(_assertThisInitialized(_this), "actions", {
      fetchAppContextV2: function fetchAppContextV2() {
        // @ts-ignore
        fetchSac(_this.props.xhrHost, _this.updateState, function () {
          if (!_this.state.properties) {
            _this.showErrorBanner = true;
            dispatchErrorEvent();
          }
        });
      },
      setContractAccountId: function setContractAccountId(contractAccountId) {
        _this.updateState({
          contractAccountId: contractAccountId
        });
      },
      setPremiseId: function setPremiseId(premiseId) {
        AemContextHub.setPremiseId(premiseId);

        _this.updateState({
          premiseId: premiseId
        });
      },
      setSelectedAddressId: function setSelectedAddressId(selectedAddressId) {
        _this.updateState({
          selectedAddressId: selectedAddressId
        });

        AemContextHub.setPremiseId(_this.state.premiseId);
      },
      setSelectedServiceId: function setSelectedServiceId(selectedServiceId) {
        _this.updateState({
          selectedServiceId: selectedServiceId
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "addSacUpdateListener", function () {
      // this is used to sync when there are two SACs on one page
      _this.sacListenerUnSub = eventDispatcher.addListener(TOPICS.SAC_UPDATE, function (topic) {
        if (topic.topic === TOPICS.SAC_UPDATE) {
          var action = topic.payload.action;
          var _this$actions = _this.actions,
              setPremiseId = _this$actions.setPremiseId,
              setContractAccountId = _this$actions.setContractAccountId,
              setSelectedAddressId = _this$actions.setSelectedAddressId,
              setSelectedServiceId = _this$actions.setSelectedServiceId,
              fetchAppContextV2 = _this$actions.fetchAppContextV2;

          if (action) {
            switch (action.action) {
              case SacAction.setPremiseId:
                setPremiseId(action.parameters.premiseId);
                break;

              case SacAction.setSelectedAddressId:
                setSelectedAddressId(action.parameters.addressId);
                break;

              case SacAction.setContractAccountId:
                setContractAccountId(action.parameters.contractAccountId);
                break;

              case SacAction.setSelectedServiceId:
                setSelectedServiceId(action.parameters.serviceId);
                break;

              case SacAction.fetchXhrAppContext:
                fetchAppContextV2();
                break;

              default:
                throw new Error('SAC action provided does not exist: ' + action);
            }
          } else if (topic.payload.srcUniqueId !== srcUniqueId) {
            // ensures that we don't listen for our own event
            _this.updateState(readStorage(), true);
          }
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "initState", function (storage, queryParams) {
      var initialisedState = getInitialisedState(storage, queryParams);

      if (storage.premiseId !== initialisedState.premiseId || storage.contractAccountId !== initialisedState.contractAccountId || storage.selectedAddressId !== initialisedState.selectedAddressId || storage.selectedServiceId !== initialisedState.selectedServiceId) {
        updateStorage(initialisedState);
      }

      return initialisedState;
    });

    _defineProperty(_assertThisInitialized(_this), "updateState", function (newState, dontFireEvent) {
      // ensures that state has changed
      var changedState = findChangedState(_this.state, newState);
      changedState = _objectSpread({}, changedState, {}, getStateChangeFromQueryParams(_this.queryParams));

      if (_Object$keys(changedState).length > 0) {
        var updatedState = updateState(_this.state, changedState); // only allow query params change state once

        if (_this.queryParams) {
          _this.queryParams = undefined;
        }

        _this.setState(updatedState, function () {
          updateStorage(_this.state, dontFireEvent); // hides the error banner if previously shown

          if (_this.state.addresses && _this.showErrorBanner) {
            _this.showErrorBanner = false;
            dispatchNoErrorEvent();
          }
        });
      }
    });

    _this.init();

    return _this;
  }

  _createClass(SharedAppContextV2Provider, [{
    key: "init",
    value: function init() {
      var queryParams = queryState();
      var isNative = isNativeFn();
      var stateFromConfig = this.props.stateFromConfig;

      if (stateFromConfig) {
        if (process.env.NODE_ENV !== "production") {
          this.state = _objectSpread({}, stateFromConfig, {}, queryParams, {
            isNative: isNative
          });
          return;
        } else {
          logger.error('@od/sac should not be initialized via props outside of DEV');
        }
      }

      var storage = readStorage();
      var derivedStorage = this.initState(storage, queryParams);

      if (!derivedStorage.addresses) {
        // save these to be used once we have properties
        this.queryParams = queryParams;
      }

      this.state = _objectSpread({}, derivedStorage, {
        isNative: isNative
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // this is used to sync SACs across multiple webviews
      this.storageListenerUnSub = addStorageUpdatedListener(function () {
        return _this2.updateState(readStorage(), true);
      });
      this.addSacUpdateListener();

      if (this.props.xhrInitialize) {
        this.actions.fetchAppContextV2();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.storageListenerUnSub) {
        removeStorageUpdatedListener(this.storageListenerUnSub);
        this.storageListenerUnSub = undefined;
      }

      if (this.sacListenerUnSub) {
        this.sacListenerUnSub();
        this.sacListenerUnSub = undefined;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var value = _objectSpread({}, this.state, {
        actions: this.actions
      });

      return /*#__PURE__*/React.createElement(SharedAppContextV2.Provider, {
        value: value
      }, this.props.children);
    }
  }]);

  return SharedAppContextV2Provider;
}(React.Component);

export { SharedAppContextV2Provider };